import Cookies from "js-cookie";

export default (totalBasketItems) => {
    // Set total basket items amount for future usage.
    Cookies.set("basket_items_amount", totalBasketItems, {
        expires: 30,
    });
};
